module.exports = __webpack_public_path__ + "img/4888.0e8baa6c.png";